import type {RowWithId} from './primitives/types'

// A fall back sort order to ensure more stable sorting that sorts by
// the item's prioritized index (client version of the priority)
// when two items appear to have the same value.
// If the prioritized index is not reset by createPageQueryDataFromItems, the value
// will be the item's id.
/**
 *
 * @deprecated - prioritizedIndex is not assigned for items in paginated views.
 * createPageQueryDataFromItems does not exist since PWL reached general availability
 * and so client-side sorting by prioritized index is not currently supported.
 * Relates to: https://github.com/github/projects-platform/issues/3099
 */
export const stableSortFn = (a: RowWithId, b: RowWithId) => {
  return a.prioritizedIndex - b.prioritizedIndex
}
